// starter-app-door.ts — the one finished app an empty workspace can open.
//
// WHY THIS EXISTS (measured, 2026-08-25): a workspace with no projects had no
// door to a runnable app at all. `작업 → 스타터 둘러보기` renders
// "템플릿을 찾지 못했습니다" because `getTemplateCatalog()`
// (features/page-editor/services/template-loader.ts) returns `[]`
// unconditionally — `packages/cogo-schema/template-catalog.json` is empty and
// `LOCAL_STUDIO_TEMPLATE_THUMBNAILS` is an empty Set, both PARKED on purpose
// (commit cd3e3bb44, "Parked 2026-08-21 with apps-backup-20260821"). So the
// gallery is not the door and must not be un-parked to make one.
//
// The opening that already exists is the bundle itself. `apps/cogo-studio/
// public/apps/newsletter-membership/` is a complete v2 bundle (app.json
// schemaVersion 3.0, 2 pages, 4 blocks, design-system.json), and
// `loadTemplateWithBundle` fetches `/apps/{id}/…` directly — it NEVER consults
// the catalogue. Its only refusal is the commerce check, and `templateDomain()`
// returns `undefined` for an id the (empty) catalogue does not list, so this
// bundle is loadable today. This module names that id in ONE place so the
// dashboard door and its gate read the same value.
//
// THE ID IS NOT SELF-VALIDATING — its gate is derived from the two consumers
// that actually honour it (see `overview-starter-door.test.tsx`):
//   1. the static bundle on disk under `public/apps/<templateId>/app.json`,
//      which is what `loadTemplateWithBundle`'s fetch resolves against. Rename
//      the directory, or this id, and the door 404s.
//   2. `createStudioOutcomeGenerationContract(STUDIO_NEWSLETTER_MEMBERSHIP_SKU_ID)`
//      (features/productization/studio-outcome-catalog.ts), the product
//      contract the dashboard's featured outcome already advertises. Pointing
//      this door at some OTHER bundle would open something the surface never
//      promised, so the gate pins the loaded pages/blocks to that contract.

export const STARTER_APP_DOOR = {
  /**
   * Bundle id under `public/apps/`, handed straight to
   * `createServerProject(name, templateId)` → `loadTemplateWithBundle`.
   */
  templateId: 'newsletter-membership',
} as const
